import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af1f6266"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-component" }
const _hoisted_2 = { class: "organizetion-title" }
const _hoisted_3 = { class: "organizetion-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_multi_level = _resolveComponent("multi-level")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input, {
        value: _ctx.searchKey,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKey) = $event)),
        placeholder: "搜索部门",
        allowClear: ""
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_multi_level, {
        "show-operation": !_ctx.hadSunloginWeb,
        list: _ctx.showList,
        modelValue: _ctx.selectedId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedId) = $event))
      }, null, 8, ["show-operation", "list", "modelValue"])
    ])
  ]))
}